import React from "react";

const Savings = () => {
  return (
    <section className="grid-section">
      <div className="grid-container">
        <h2>Savings is not currently available.</h2>
      </div>
    </section>
  );
};

export default Savings;
